import React from "react";
import { Link } from "gatsby";

const Index = ({ title, description, btnLink, btnText }) => {
  return (
    <header className="header h-screen overflow-auto d-flex align-items-end">
      <div className="container">
        <div className="row d-flex">
          <div className="col-lg-8">
            {title ? title : null}
            {description ? description : null}

            {btnText && btnLink ? (
              <Link
                className="btn-solid-lg fs-5 discover-more-btn"
                to={btnLink}
                role="button"
              >
                {btnText}
              </Link>
            ) : null}
          </div>
        </div>
      </div>

      <video
        poster="/videos/poster/hero-bg.webp"
        className="background-video bg-blue"
        playsInline
        autoPlay
        muted
      >
        <source src="/videos/hero-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </header>
  );
};

export default Index;
